import React, {ReactNode} from 'react';

import {Trans} from '../../../../../libs/shared/helpers/src/internationalization/react';
import {IconName} from '../../../../../libs/shared/ui/src/components/icon/icon';
import {AnalyticsFilterTypesEnum} from '../../../../models/api/analyticsSavedViewModel';

/*
 * Types.
 */

type FilterWithIds =
  | AnalyticsFilterTypesEnum.CHANNELS
  | AnalyticsFilterTypesEnum.TEAMMATES
  | AnalyticsFilterTypesEnum.INBOXES
  | AnalyticsFilterTypesEnum.ACCOUNTS
  | AnalyticsFilterTypesEnum.TEAMS
  | AnalyticsFilterTypesEnum.EXCLUDE_TAGS
  | AnalyticsFilterTypesEnum.TAGS
  | AnalyticsFilterTypesEnum.WITHOUT_TAGS;

type FilterConfig = {name: ReactNode; iconName: IconName; activeIconName: IconName};
type AnalyticsFiltersConfig = Record<FilterWithIds, FilterConfig>;

export const analyticsFiltersConfig: AnalyticsFiltersConfig = {
  [AnalyticsFilterTypesEnum.TEAMS]: {
    name: <Trans id="analytics-filters-team">Teams</Trans>,
    iconName: 'meetingBuildingSmall',
    activeIconName: 'buildingFilledSmall',
  },
  [AnalyticsFilterTypesEnum.TEAMMATES]: {
    name: <Trans id="analytics-filters-teammate">Teammates</Trans>,
    iconName: 'teammatesSmall',
    activeIconName: 'teammatesFilledSmall',
  },
  [AnalyticsFilterTypesEnum.CHANNELS]: {
    name: <Trans id="analytics-filters-channels">Channels</Trans>,
    iconName: 'channelsSmall',
    activeIconName: 'channelsFilledSmall',
  },
  [AnalyticsFilterTypesEnum.INBOXES]: {
    name: <Trans id="analytics-filters-inboxes">Inboxes</Trans>,
    iconName: 'inboxSmall',
    activeIconName: 'inboxFilledSmall',
  },
  [AnalyticsFilterTypesEnum.ACCOUNTS]: {
    name: <Trans id="analytics-filters-account">Accounts</Trans>,
    iconName: 'briefcaseOutlineSmall',
    activeIconName: 'briefcaseFilledSmall',
  },
  [AnalyticsFilterTypesEnum.EXCLUDE_TAGS]: {
    name: <Trans id="analytics-filters-exclude-tags">Exclude tags</Trans>,
    iconName: 'noTagSmall',
    activeIconName: 'tagIsNotFilledSmall',
  },
  [AnalyticsFilterTypesEnum.TAGS]: {
    name: <Trans id="analytics-filters-tags">Tags</Trans>,
    iconName: 'tagSmall',
    activeIconName: 'tagFilledSmall',
  },
  // Not used in the filters bar, but needed for rendering the filters
  // for a saved view
  [AnalyticsFilterTypesEnum.WITHOUT_TAGS]: {
    name: <Trans id="analytics-filters-without-tags">Without tags</Trans>,
    iconName: 'noneSmall',
    activeIconName: 'noneSmall',
  },
};
